<template>
  <div class="auth-page">
    <!-- 登入表單 -->
    <section class="auth-section">
      <div class="container">
        <div class="auth-card">
          <form @submit.prevent="handleLogin" class="auth-form">
            <!-- 帳號 -->
            <div class="form-group">
              <label for="email">信箱</label>
              <div class="input-wrapper">
                <i class="fas fa-user input-icon"></i>
                <input
                  type="text"
                  id="email"
                  v-model="form.email"
                  placeholder="請輸入您的信箱"
                  required
                />
              </div>
              <span v-if="errors.email" class="error">{{ errors.email }}</span>
            </div>

            <!-- 密碼 -->
            <div class="form-group">
              <label for="password">密碼</label>
              <div class="input-wrapper">
                <i class="fas fa-lock input-icon"></i>
                <input
                  :type="showPassword ? 'text' : 'password'"
                  id="password"
                  v-model="form.password"
                  placeholder="請輸入您的密碼"
                  required
                />
                <i
                  :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"
                  @click="togglePassword"
                  class="toggle-password"
                ></i>
              </div>
              <span v-if="errors.password" class="error">{{
                errors.password
              }}</span>
            </div>

            <!-- 驗證碼 -->
            <div class="form-group">
              <label for="captcha">驗證碼</label>
              <div class="captcha-wrapper">
                <div class="input-wrapper">
                  <i class="fas fa-shield-alt input-icon"></i>
                  <input
                    type="text"
                    id="captcha"
                    v-model="form.captcha"
                    placeholder="請輸入驗證碼"
                    maxlength="4"
                    required
                  />
                </div>
                <div class="captcha-display">
                  <span>{{ captchaCode }}</span>
                  <button
                    type="button"
                    @click="refreshCaptcha"
                    class="refresh-btn"
                  >
                    <i class="fas fa-sync-alt"></i>
                  </button>
                </div>
              </div>
              <span v-if="errors.captcha" class="error">{{
                errors.captcha
              }}</span>
            </div>

            <!-- 社交登入按鈕 -->
            <div class="social-login-wrapper">
              <button
                class="gsi-material-button"
                type="button"
                @click="handleGoogleLogin"
              >
                <div class="gsi-material-button-state"></div>
                <div class="gsi-material-button-content-wrapper">
                  <div class="gsi-material-button-icon">
                    <svg
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 48 48"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      style="display: block"
                    >
                      <path
                        fill="#EA4335"
                        d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
                      ></path>
                      <path
                        fill="#4285F4"
                        d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
                      ></path>
                      <path
                        fill="#FBBC05"
                        d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
                      ></path>
                      <path
                        fill="#34A853"
                        d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
                      ></path>
                      <path fill="none" d="M0 0h48v48H0z"></path>
                    </svg>
                  </div>
                  <span class="gsi-material-button-contents"
                    >Sign in with Google</span
                  >
                  <span style="display: none">Sign in with Google</span>
                </div>
              </button>
              <button
                type="button"
                @click="handleLineLogin"
                class="btn-social line-btn"
                
              >
                <i class="fab fa-line"></i>
                LINE 登入
              </button>
            </div>

            <!-- 提交按鈕 -->
            <button type="submit" class="login">登入</button>

            <!-- 其他連結 -->
            <p class="auth-link">
              還沒有帳號？<router-link to="/register" class="link"
                >立即註冊</router-link
              >
            </p>
            <p class="auth-link">
              <router-link to="/forgot" class="link">忘記密碼？</router-link>
            </p>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script src="@/assets/js/login.js"  defer></script>

<style scoped src="@/assets/css/login.css"></style>
